import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginInfo: JSON.parse(sessionStorage.getItem('loginInfo') || '{}'),
    userToken: sessionStorage.getItem('userToken') || '',
    menus: JSON.parse(sessionStorage.getItem('menus') || '[]'),
    dataState: sessionStorage.getItem('state') || 0,
    slideTop: sessionStorage.getItem('slideTop') || null,
    agencyInfo: JSON.parse(sessionStorage.getItem('agencyInfo') || '{}')
  },
  getters: {},
  mutations: {
    // 保存登录后的个人信息
    SAVELOGININFO(state, payload) {
      state.loginInfo = payload
      sessionStorage.setItem('loginInfo', JSON.stringify(payload))
    },
    // 保存登录后的token
    SAVETOKEN(state, payload) {
      state.userToken = payload
      sessionStorage.setItem('userToken', payload)
    },
    // 保存菜单
    SETMENU(state, payload) {
      state.menus = payload
      sessionStorage.setItem('menus', JSON.stringify(payload))
    },
    // 用于移动端页面，保存是未评还是已评
    SAVESTATE(state, payload) {
      state.dataState = payload
      sessionStorage.setItem('dataState', payload)
    },
    // 保存左侧导航菜单蓝色滑块的高度
    SAVEHEIGHT(state, payload) {
      state.slideTop = payload
      sessionStorage.setItem('slideTop', payload)
    },
    // 代理机构登录后，存储id、name、code、信息
    SAVEAGENCYINFO(state, payload) {
      state.agencyInfo = payload
      sessionStorage.setItem('agencyInfo', JSON.stringify(payload))
    },
    // 代理机构首次登录后，填写基本信息后保存
    CHANGSTATU(state) {
      state.agencyInfo.isFilled = 1
      sessionStorage.setItem('agencyInfo', JSON.stringify(state.agencyInfo))
    }
  },
  actions: {},
  modules: {}
})
